import { render, staticRenderFns } from "./DropSimple.vue?vue&type=template&id=c8d276f8"
import script from "./DropSimple.vue?vue&type=script&lang=js"
export * from "./DropSimple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports